module.exports = __webpack_public_path__ + "img/品牌课程@2x.adc4ee34.png";